import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import ItemInspecaoFrota from "model/gestao/frotas/ItemInspecaoFrota";
import MarcaVeiculo from "model/gestao/frotas/MarcaVeiculo";
import Veiculo from "model/gestao/frotas/Veiculo";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class VeiculoService implements BaseServiceCadastros<Veiculo> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/veiculo/pesquisar`;
            url += getFilters(filters);


            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Veiculo>((resolve, reject): void => {
            api
                .get(`/veiculo/consultar/${id}`)
                .then(response => {
                    const veiculo: Veiculo = response.data;
                    veiculo.itensInspecao.forEach(item => {
                        item.key = generateKey();
                        return item;
                    });

                    resolve(veiculo)
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(veiculo: Veiculo) {
        return new Promise<Veiculo>((resolve, reject): void => {
            apiFile
                .post(`/veiculo/incluir`, veiculo)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(veiculo: Veiculo) {
        return new Promise<Veiculo>((resolve, reject): void => {
            apiFile
                .put(`/veiculo/editar`, veiculo)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/veiculo/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    marcasDisponiveis() {
        return new Promise<MarcaVeiculo[]>((resolve, reject): void => {
            api
                .get(`/veiculo/marcas`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuariosDisponiveis() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/veiculo/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    itensInspecaoDisponiveis() {
        return new Promise<ItemInspecaoFrota[]>((resolve, reject): void => {
            api
                .get(`/veiculo/itensInspecaoDisponives`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getPeriodicidadeLista() {
        return [{
            value: 'DIAS',
            label: 'Dias'
        },
        {
            value: 'MESES',
            label: 'Meses'
        },
        {
            value: 'ANOS',
            label: 'Anos'
        }]
    }

    getPeriodicidade(periodicidade: string): string {
        let periodicidadeObj = this.getPeriodicidadeLista().find((item) => item.value === periodicidade)
        if (periodicidadeObj) {
            return periodicidadeObj.label
        }
        return "";
    }

}

export default VeiculoService;